<template>
  <section
    class="hero section"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color'
    ]"
  >
    <div class="container">
      <div
        class="hero-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider'
        ]"
      >
        <div
          class="split-wrap"
          :class="[
            invertMobile && 'invert-mobile',
            invertDesktop && 'invert-desktop',
            alignTop && 'align-top'
          ]"
        >
          <div class="split-item">
            <div class="hero-content split-item-content center-content-mobile">
              <h1 class="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="150">
                Help your clients build Version 1.0 of their B2B app RAPIDLY,
                even if you're not a dev agency.
              </h1>
              <p class="mt-0 mb-32 reveal-from-bottom" data-reveal-delay="300">
                I partner with design agencies & marketing agencies to give you
                in-house dev super powers.
              </p>
              <div class="reveal-from-bottom" data-reveal-delay="450">
                <CSmoothScoll to="welcome">
                  <c-button tag="a" color="primary" wide-mobile>Find out more</c-button>
                </CSmoothScoll>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionSplitProps } from "@/utils/SectionProps.js";
import CButton from "@/components/elements/Button.vue";
import CSmoothScoll from "@/components/elements/SmoothScroll.vue";

export default {
  name: "CHeroSplit",
  components: {
    CButton,
    CSmoothScoll
  },
  mixins: [SectionSplitProps]
};
</script>

<style scoped>
@media (min-width: 641px) {
  .split-wrap .split-item {
    min-height: 492px;
  }
}
</style>
